module.exports = __webpack_public_path__ + "img/home-slide-2.b929bdd5.jpg";